<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <label :for="'inputField_' + inputData.id" class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
        <div class="form__input-container">
            <input class="form__input form__input--zip"
                :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                type="number"
                pattern="[0-9]{4}"
                inputmode="numeric"
                placeholder=""
                :id="'inputField_' + inputData.id"
                :name="'input_' + inputData.id"
                :required="inputData.required"
                :class="inputData.error ? 'form__input--error' : ''"
                @keyup="getCity($event.target.value)"
                v-model="zipCode">
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <label class="form__heading form__heading--autocomplete" :for="'input_' + inputData.id + '_city'">
            <span>{{ $t('city')}}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <div class="form__input-container" :class="loadingClass">
            <input class="form__input form__input--text " :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                type="text"
                :id="'input_' + inputData.id + '_city'"
                :name="'input_' + inputData.id + '_city'"
                v-model="city">
        </div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData'],
    emits: ['inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            zipCode: this.inputData.value ? this.inputData.value : '',
            city: '',
            fetchingCityName: false,
        }
    },
    methods: {
        getCity(zipCode){
            if (zipCode.length === 4){
                this.fetchingCityName = true;
                fetch(`/xhr/v1/frontend/zip?zip=${zipCode}`)
                .then(response => response.json())
                .then(data => {
                    this.fetchingCityName = false;
                    if (!data.postal_codes) {
                        return;
                    }

                    this.city = data.postal_codes[0].city;
                });
            } else {
                this.city = "";
            }
        },
        getInputValue(){
            return JSON.stringify({
                zipcode: this.zipCode,
                city: this.city
            });
        }
    },
    computed: {
        loadingClass(){
            if(this.fetchingCityName){
                return "form__input-container--loading";
            }
            return ""
        }
    },
    watch: {
        zipCode(){
            this.$emit('inputValue', this.inputData.id, this.getInputValue());
        },
        city(){
            this.$emit('inputValue', this.inputData.id, this.getInputValue());
        },
        inputData: {
            handler(){
                if(this.inputData.value){
                    let inputDataParsed  = JSON.parse(this.inputData.value);
                    this.zipCode = inputDataParsed.zipcode;
                    this.city = inputDataParsed.city;
                }
            },
            deep: true
        }
    }
}
</script>